import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';
import {AcceptanceRule} from "./acceptance-rule";
import AcceptanceRuleType = AcceptanceRule.AcceptanceRuleType;
import {CommRate} from "../billing/comm-rate";
import RuleType = CommRate.RuleType;

export class BrokerageTable {

  @JsonProperty()
  id: number = -1;
  @JsonProperty()
  brokerageTableName: string | undefined;

  @JsonProperty()
  clearingHouse: string | undefined;
  @JsonProperty()
  exchangeCode: string | undefined;
  @JsonProperty()
  contractCode: string | undefined;
  @JsonProperty()
  contractUnit: string | undefined;

  @JsonProperty()
  allFutures: boolean;
  @JsonProperty()
  allOptions: boolean;

  @JsonProperty()
  ownerId: number;
  @JsonProperty()
  ownerCode: string | undefined;

  @JsonProperty()
  ruleType: RuleType;
  @JsonProperty()
  amountPerLot: number;
  @JsonProperty()
  currency: string | undefined;

  @JsonProperty()
  creationDate: DateTime = DateTime.now();
  @JsonProperty()
  modificationDate: DateTime = DateTime.now();

}
